<div class="loading flex flex-column items-center">
  <stxt-svg-icon [iconConfig]="logoSvg" class="loading_logo"></stxt-svg-icon>
  <div class="loading_text">{{ loadingText }}</div>
</div>
